import React, { ForwardedRef, ReactElement, forwardRef } from "react";
import { FaCheckCircle, FaExclamationCircle, FaSpinner } from "react-icons/fa";
import Input, { InputProps, InputUIProps } from "./input";
import "./stateInput.css";

export interface StateInputUIProps extends InputUIProps {
    uiState?: "pending" | "error" | "success";
    uiPendingIcon?: ReactElement;
    uiSuccessIcon?: ReactElement;
    uiErrorIcon?: ReactElement;
}

export type StateInputProps = InputProps & StateInputUIProps;

const StateInput = forwardRef(function StateInput(
    props: StateInputProps,
    ref: ForwardedRef<HTMLInputElement>
) {
    const {
        uiState,
        uiPendingIcon,
        uiSuccessIcon,
        uiErrorIcon,
        uiDisabled,
        children,
        ...other
    } = props;

    let icon: ReactElement | null = null;
    if (uiState === "pending") {
        icon =
            uiPendingIcon || (
                <FaSpinner className="state-input__icon state-input__icon--pending state-input__spinner" />
            );
    } else if (uiState === "success") {
        icon =
            uiSuccessIcon || (
                <FaCheckCircle className="state-input__icon state-input__icon--success" />
            );
    } else if (uiState === "error") {
        icon =
            uiErrorIcon || (
                <FaExclamationCircle className="state-input__icon state-input__icon--error" />
            );
    }

    return (
        <Input
            {...other}
            uiDisabled={uiDisabled || uiState === "pending"}
            ref={ref}
        >
            {children}
            {icon}
        </Input>
    );
});

export default StateInput;
